import { Injectable } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';

import { CustomValidatorsType } from '@global-components/classes/custom-validators';
import { ToastrService } from 'ngx-toastr';

type Datos<T> = { [K in keyof T]: T[K] | GlobalFormulario<T[K]> };
export interface GlobalFormulario<T> {
  datos: Datos<T>;
  disabled?: { [key in keyof T]?: boolean };
  validaciones?: { [key in keyof T]?: ValidationErrors[] };
  validacionesGlobales?: ValidatorFn | ValidatorFn[];
  updateOn?: { [key in keyof T]?: 'change' };
}
export type GlobalControl<T> = { [K in keyof T & string]: GlobalFormGroup<T[K]> };
export type GlobalAbstractControl<T> = { [K in keyof T & string]: AbstractControl };
export interface GlobalFormGroup<T> extends FormGroup {
  value: T;
  controls: GlobalControl<T> & GlobalAbstractControl<T>;
  errors: CustomValidatorsType;
  setValue: (values: T) => void
  valueChanges: Observable<T>;
  getRawValue: () => T
}
@Injectable()
export class FormularioService {
  constructor(private readonly formBuilder: FormBuilder, private readonly toastrService: ToastrService) {}

  construirFormulario<T>(globalFormulario: GlobalFormulario<T>) {
    const validaciones = globalFormulario.validaciones || {};
    const updateOn = globalFormulario.updateOn || {};
    const disabled = globalFormulario.disabled || {};
    const form = Object.keys(globalFormulario.datos).reduce((acc, key) => {
      if (globalFormulario.datos[key] !== null && typeof globalFormulario.datos[key] === 'object' && !Array.isArray(globalFormulario.datos[key])) {
        acc[key] = this.construirFormulario(globalFormulario.datos[key]);
      } else {
        acc[key] = [{ value: globalFormulario.datos[key], disabled: disabled[key] }, { validators: validaciones[key], updateOn: updateOn[key] || 'blur' }];
      }
      return acc;
    }, {});

    return this.formBuilder.group(form, { validators: globalFormulario.validacionesGlobales }) as GlobalFormGroup<T>;
  }
  private marcarComoTocado<T>(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.marcarComoTocado(control);
      }
    });
  }
  validarCampos(formGroup: FormGroup) {
    if(!formGroup.dirty) {
      this.toastrService.info('No ha habido cambios en el formulario');
      return false;
    }
    if(formGroup.invalid) {
      this.toastrService.info('Formulario invalido. Revisa los campos');
      this.marcarComoTocado(formGroup);
      return false;
    }
    return true;
  }
}
